import { Button, Card, CardContent, CardDescription, CardGroup, CardHeader, CardMeta } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import ErrorsView from "./ErrorsView";
import { LicenceProduct } from "../models/LicenceProduct";
import { useState } from "react";

export interface FormData {
  productId: string;
  productName: string;
  numberOfUsers: number;
  totalPrice: number;
  licenceType: string;
  organizationId: string;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  products?: LicenceProduct[] | null;
}

const AddLicenceForm = ({ formData, errors, onChange, products }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<LicenceProduct>();

  const handleProductClick = (product: LicenceProduct) => {
    setSelectedProduct(product);
    onChange({
      ...formData,
      productId: product.id,
      productName: product.name,
      numberOfUsers: product.numberOfUsers,
      totalPrice: product.totalPrice,
      licenceType: product.licenceType,
    });
  };

  return (
    <>
      <CardGroup itemsPerRow={3}>
        {products?.map((p) => (
          <Card color={p === selectedProduct ? "green" : "grey"} onClick={(e) => handleProductClick(p)}>
            <CardContent>
              <Button
                icon={p === selectedProduct ? "dot circle outline" : "circle outline"}
                floated="right"
                basic
                compact
                size="large"
                style={{ boxShadow: "none", padding: 0 }}
              />
              <CardHeader>{p.name}</CardHeader>
              <CardMeta>Number of users: {p.numberOfUsers}</CardMeta>
              <CardDescription>
                Unit price:&nbsp;
                {new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "GBP",
                }).format(p.totalPrice / p.numberOfUsers)}
              </CardDescription>
            </CardContent>
            <CardContent extra>
              Total price:&nbsp;
              {new Intl.NumberFormat("en-GB", {
                style: "currency",
                currency: "GBP",
              }).format(p.totalPrice)}
            </CardContent>
          </Card>
        ))}
      </CardGroup>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddLicenceForm;
